import React from "react";
import withIntl from "../../utils/withIntl";
import { Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import GenericForm from "../Forms/GenericForm";
import { useParams } from "react-router-dom";
import cloudStore from "../../store/CloudStore";
import { updateSpMerchant } from "../../store/SpMerchantApi";

const useStyles = makeStyles({
  createPosPaperContainer: { padding: 10, width: "100%", margin: 20 },
});

function AyceForm(props) {
  const classes = useStyles();
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const spMerchant = cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);
  const [formData, setFormData] = React.useState([
    {
      label: "time_interval",
      value: spMerchant.sp_ayce_setting ? spMerchant.sp_ayce_setting.time_interval : "",
      type: "number",
      field: "text",
    },
    {
      label: "couvert_multiplier",
      value: spMerchant.sp_ayce_setting ? spMerchant.sp_ayce_setting.couvert_multiplier : "",
      type: "number",
      field: "text",
    },
    {
      label: "ordergroups",
      value: spMerchant.sp_ayce_setting ? spMerchant.sp_ayce_setting.ordergroups : "",
      type: "number",
      field: "text",
    },
    {
      label: "max_different_plus",
      value: spMerchant.sp_ayce_setting ? spMerchant.sp_ayce_setting.max_different_plus : "",
      type: "number",
      field: "text",
    },
  ]);

  return (
    <div>
      <Paper classes={{ root: classes.createPosPaperContainer }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FastfoodIcon fontSize={"large"} />
          <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
            All You Can Eat
          </Typography>
        </div>
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
        <GenericForm
          formData={formData}
          onChangeFields={(value, setting) => {
            let newFormData = [...formData];
            let newSetting = { ...setting, value: value };
            let index = newFormData.findIndex((setting2) => setting2.label === setting.label);
            newFormData.splice(index, 1, newSetting);
            setFormData(newFormData);
          }}
          onSubmit={() => {
            let newData = { sp_ayce_setting: {} };
            formData.map((setting) => {
              newData.sp_ayce_setting[setting.label] = setting.value;
            });
            updateSpMerchant(spMerchant, newData, []);
          }}
        />
      </Paper>
    </div>
  );
}

export default withIntl(AyceForm);
